import {DownOutlined, SyncOutlined} from '@ant-design/icons';
import {Table, Col, Tag, Dropdown, Space, Row} from 'antd';
import axios from 'axios';
import {baseURL} from '../service/ApiService';
import React, { useEffect, useState } from 'react';
import GptModelEditModal from "../modal/GptModelEditModal";
import GptPromptEditModal from "../modal/GptPromptEditModal";
import GptTestPromptModal from "../modal/GptTestPromptModal";
import GptPromptAddModal from "../modal/GptPromptAddModal";

const GptPromptTable = () => {
    const [tableParams, setTableParams] = useState({
        pagination: {
            current: 1,
            pageSize: 10,
        },
    });
    const updateTable = async () => {
        axios.get(`${baseURL}/api/prompt?page=${tableParams.pagination.current - 1}&size=${tableParams.pagination.pageSize}`).then(
            (res) => {
                console.log(res.data.content);
                setDataSource(res.data.content.map(item => (
                    { key: item.id,
                        id: item.id,
                        description: item.description,
                        promptChinese:      item.promptChinese,
                        promptEnglish:      item.promptEnglish,
                        promptJapanese:     item.promptJapanese,
                        promptCantonese:    item.promptCantonese,
                        promptChineseTaiwan:item.promptChineseTaiwan,
                        promptFrench:       item.promptFrench,
                        promptHindi:        item.promptHindi,
                        promptSpanish:      item.promptSpanish,
                        promptPortuguese:   item.promptPortuguese,
                        promptArabic:       item.promptArabic,
                        promptRussian:      item.promptRussian,
                        promptKorean:       item.promptKorean,
                        jsonMode: item.jsonMode,
                        config: item.config,
                        model: item.gptModelDatabase,
                        cost: item.cost
                    })));
                setTableParams({
                    ...tableParams,
                    pagination: {
                        ...tableParams.pagination,
                        total: res.data.totalElements,
                        showTotal: (total) => `Total ${total} prompts`
                    },
                });
                setLoading(false);
            }
        );
    }
    useEffect(() => {
        updateTable();
        getCurrentModel();
    }, [JSON.stringify(tableParams)])

    const columns = [
        {
            title: 'ID',
            dataIndex: 'id',
            fixed: 'left',
        },
        {
            title: 'Name',
            dataIndex: 'description',
            width: 100,
        },
        {
            title: 'Model in use',
            dataIndex: 'model',
            width: 100,
            render: row => {
                return row.modelName;
            }
        },
        // {
        //     title: 'Prompt text (Chinese)',
        //     dataIndex: 'promptChinese',
        //     editable: true,
        //     render: (text) => {
        //         const regex = /\${([^}]+)}/g;
        //         const boldText = text.replace(regex, '<strong>$&</strong>');
        //         return <div dangerouslySetInnerHTML={{ __html: boldText }} />;
        //     },
        // },
        {
            title: 'Prompt text (English)',
            dataIndex: 'promptEnglish',
            editable: true,
            render: (text) => {
                const regex = /\${([^}]+)}/g;
                const boldText = text.replace(regex, '<strong>$&</strong>');
                return <div dangerouslySetInnerHTML={{ __html: boldText }} />;
            },
        },
        {
            title: 'JSON Mode',
            width: 100,
            render: row => row.jsonMode?'Yes':'No',
        },
        {
            title: 'Token Cost',
            dataIndex: 'cost',
            width: 100,
        },
        {
            title: 'Action',
            key: 'operation',
            fixed: 'right',
            width: 100,
            render: (row) => {
                return (
                    <Dropdown
                        menu={{
                            items: [
                                {
                                    key: 'editPrompt',
                                    label: (<GptPromptEditModal buttonName={'Edit Prompt'} title={'Edit Prompt'} prompt={row} models={gptModels} callback={updateTable} />),
                                },
                                {
                                    key: 'testPrompt',
                                    label: (<GptTestPromptModal buttonName={'Test Prompt'} title={row.description.toUpperCase()} prompt={row} callback={updateTable} />),
                                },
                            ],
                        }}
                    >
                        <a onClick={(e) => e.preventDefault()}>
                            <Space>
                                Action
                                <DownOutlined />
                            </Space>
                        </a>
                    </Dropdown>
                );
            }
        },
    ];
    const [dataSource, setDataSource] = useState([]);
    const [loading, setLoading] = useState(true);
    const [gptModels, setGptModels] = useState([])
    const getCurrentModel = async () => {
        axios.get(`${baseURL}/api/web/gpt-models`).then(
            (res) => {
                console.log(res.data);
                setGptModels(res.data);
                setLoading(false)
            }
        );
    }
    const handleTableChange = (pagination, filters, sorter) => {
        setTableParams({
            pagination,
            filters,
            ...sorter,
        });

        // `dataSource` is useless since `pageSize` changed
        if (pagination.pageSize !== tableParams.pagination?.pageSize) {
            setDataSource([]);
        }
    };
    return (
        <>
            <Row justify="space-between" align="bottom" style={{ display: 'flex', marginBottom: '2px', justifyContent: 'space-between', alignItems: 'center' }}>
                <Col>
                    <Row gutter={16}>
                        {/*<Col>*/}
                        {/*    <GptModelEditModal model={gptModel?.id} buttonName={"Choose GPT Model"} title={"Choose GPT Model"} callback={() => getCurrentModel()}/>*/}

                        {/*</Col>*/}
                        <Col>
                            <GptPromptAddModal buttonName={"Add new Prompt"} title={"Add new Prompt"} models={gptModels} callback={() => updateTable()}/>
                        </Col>
                    </Row>
                </Col>
                {/*<Col>*/}
                {/*    <Tag icon={<SyncOutlined spin />} color="processing">*/}
                {/*        Powered by {gptModel?.modelName}*/}
                {/*    </Tag>*/}
                {/*</Col>*/}
            </Row>
            <Row>
                <Table rowKey="key"
                       columns={columns}
                       dataSource={dataSource}
                       pagination={tableParams.pagination}
                       onChange={handleTableChange}
                       loading={loading}>
                </Table>
            </Row>
        </>
    );
};
export default GptPromptTable;